﻿import { getNewPath } from "./commonHelpers";

export const SET_VISIBILITY_FILTER = "SET_VISIBILITY_FILTER";
export const SUBMIT_DATA = "SUBMIT_DATA";
export const CLEAR_DATA = "CLEAR_DATA";
export const SET_USER_DATA = "SET_USER_DATA";
export const INCREMENT = "INCREMENT";
export const DECREMENT = "DECREMENT";
export const ADD = "ADD"
export const SUBTRACT = "SUBTRACT"
export const RESET_COUNTER = "RESET_COUNTER";
export const SELECT_VIEW = "SELECT_VIEW";
export const SELECT_MODULE = "SELECT_MODULE";
export const SET_CURRENT_POSITION = "SET_CURRENT_POSITION";
export const ADD_PLAYER_SELECTIONS = "ADD_PLAYER_SELECTIONS";
export const SET_SELECTED_ITEMS = "SET_SELECTED_ITEMS";
export const REMOVE_PLAYER_SELECTIONS = "REMOVE_PLAYER_SELECTIONS";
export const CLEAR_CURRENT_POSITION = "CLEAR_CURRENT_POSITION";
export const CLEAR_SELECTED_ITEMS = "CLEAR_SELECTED_ITEMS";
export const CREATE_ROSTER = "CREATE_ROSTER";
export const SET_BACKGROUND_LAYERS = "SET_BACKGROUND_LAYERS";
export const SET_VIDEO_DATA = "SET_VIDEO_DATA"
export const SET_ENVIRONMENT = "SET_ENVIRONMENT"
export const SET_CURRENT_PLAYER = "SET_CURRENT_PLAYER"
export const SET_PREDICTION_ID = "SET_PREDICTION_ID"
export const CLEAR_PREDICTION_ID = "CLEAR_PREDICTION_ID"
export const SET_BASE_CLASS = "SET_BASE_CLASS";
export const SET_SUBMISSION_ITEMS = "SET_SUBMISSION_ITEMS";
export const SET_VIDEO_POSTER_URL = "SET_VIDEO_POSTER_URL";
export const SET_SUBMISSIONS_PATH = "SET_SUBMISSIONS_PATH";
export const UPDATE_URL = "UPDATE_URL";
export const SET_GREATEST_MOMENT_GROUP_DATA = "SET_GREATEST_MOMENT_GROUP_DATA";
export const CLEAR_GREATEST_MOMENT_GROUP_DATA = "CLEAR_GREATEST_MOMENT_GROUP_DATA"
export const RESET_GREATEST_MOMENT_GROUP_DATA = "RESET_GREATEST_MOMENT_GROUP_DATA"
export const SET_MAX_COUNT = 'SET_MAX_COUNT'
/*
 * action creators
 */

export function setMaxCount(maxCount) {
  return {
    type: SET_MAX_COUNT,
    maxCount
  }
}

export function setSelectedItems(selectedItems) {
  return {
    type: SET_SELECTED_ITEMS,
    selectedItems
  }
}

export function setGreatestMomentGroupData(groupData) {
  return {
    type: SET_GREATEST_MOMENT_GROUP_DATA,
    groupData
  }
}

export function clearGreatestMomentGroupData() {
  return {
    type: CLEAR_GREATEST_MOMENT_GROUP_DATA
  }
}

export function resetGreatestMomentGroupData(greatestMomentData) {
  return {
    type: RESET_GREATEST_MOMENT_GROUP_DATA,
    greatestMomentData
  }
}

export function updateUrl(currentUrl, newDir) {
  const url = getNewPath(currentUrl, newDir)

  return {
    type: UPDATE_URL,
    url
  }
}

export function setSubmissionsPath(submissionsPath) {
  return {
    type: SET_SUBMISSIONS_PATH,
    submissionsPath
  }
}

export function setVideoPosterUrl(videoPosterUrl) {
  return {
    type: SET_VIDEO_POSTER_URL,
    videoPosterUrl
  }
}

export function setSubmissionItems(items) {
  return {
    type: SET_SUBMISSION_ITEMS,
    items
  }
}

export function setBaseClass(baseClass) {
  return {
    type: SET_BASE_CLASS,
    baseClass
  }
}

export function clearPredictionId() {
  return {
    type: CLEAR_PREDICTION_ID
  }
}

export function setPredictionId(predictionId) {
  return {
    type: SET_PREDICTION_ID,
    predictionId
  }
}

export function setCurrentPlayer(player) {
  return {
    type: SET_CURRENT_PLAYER,
    player
  }
}

export function setEnvironment(envData) {
  return {
    type: SET_ENVIRONMENT,
    envData
  }
}

export function setVideoData(videoData) {
  return {
    type: SET_VIDEO_DATA,
    videoData
  }
}

export function setMediaSDK(mediaSDK) {
  return {
    type: SET_MEDIASDK,
    mediaSDK
  }
}

export function setBackgroundLayers(backgroundArray) {
  return {
    type: SET_BACKGROUND_LAYERS,
    backgroundArray
  };
}

export function selectView(view) {
  return {
    type: SELECT_VIEW,
    view
  };
}

export function selectModule(module) {
  return {
    type: SELECT_MODULE,
    module
  };
}

export function setUserData(data) {
  return {
    type: SET_USER_DATA,
    data
  };
}

export function clearCurrentPosition() {
  return { type: CLEAR_CURRENT_POSITION };
}

export function clearSelectedItems() {
  return { type: CLEAR_SELECTED_ITEMS };
}

export function setCurrentPosition(position) {
  return { type: SET_CURRENT_POSITION, position };
}

export function addCurrentPlayer(player, isMaxCount) {
  return {
    type: ADD_PLAYER_SELECTIONS,
    player,
    entityId: player._entityId,
    isMaxCount
  };
}

export function removeCurrentPlayer(player, isMaxCount) {
  return {
    type: REMOVE_PLAYER_SELECTIONS,
    player,
    entityId: player._entityId,
    isMaxCount
  };
}

export function addCounter() {
  return {
    type: ADD
  };
}

export function subtractCounter() {
  return {
    type: SUBTRACT,
  };
}

export function incrementCounter(player) {
  return {
    type: INCREMENT,
    player
  };
}

export function decrementCounter(player) {
  return {
    type: DECREMENT,
    player
  };
}

export function resetCounter() {
  return {
    type: RESET_COUNTER
  };
}

export function createRoster(roster) {
  return {
    type: CREATE_ROSTER,
    roster
  };
}
